import React from "react";
import { withTranslation } from "react-i18next";
import { Comment, List, Icon } from "antd";
import moment from 'moment';
import { get, isEmpty } from 'lodash';

const dateFormat = 'lll';

class LatestComments extends React.Component {
  render() {
    const { comments, t, history } = this.props;

    return (
      <div>
        {
          !isEmpty(comments) &&
          <List
            dataSource={comments}
            header={`${comments.length} ${comments.length > 1 ? t('comments.comment_list.comments', "comments") : t('comments.comment_list.comment', "comment")}`}
            itemLayout="horizontal"
            renderItem={item => (
              <Comment
                author={
                  <div>
                    <b>{get(item, 'commented_by.first_name')} {get(item, 'commented_by.last_name')}
                      {!get(item, 'commented_by.first_name') && !get(item, 'commented_by.last_name') && 'No Name'}
                    </b> commented on {` `}
                    <a onClick={(e) => {
                      e.preventDefault()
                      history.push(`/leads/${get(item, 'lead.id')}`, { requestType: 'put' })
                    }}>
                      {get(item, ['lead', 'name'])}
                    </a> at {moment(item.commented_on).format(dateFormat)}
                  </div>
                }
                content={item.comment}
                avatar={<Icon type="wechat" />}
                datetime={`( ${moment(item.commented_on).fromNow()} )`}
              />
            )
            }
          />
        }
      </div>
    );
  }
}


export default withTranslation()(LatestComments);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/LatestComments.js